/**
 * Boligdage 2026 – fribillet-formular (bd26, progressiv forbedring).
 *
 * Formularen er en ÆGTE Shopify 'customer'-formular (contact[email] +
 * contact[tags]) — den virker fuldt ud UDEN JavaScript (fuld side-
 * indlæsning, generisk kvitteringstekst styret af form.posted_successfully?
 * i sections/boligdage-fribillet-26.liquid).
 *
 * Denne fil giver den polerede oplevelse fra designet: klientvalidering med
 * danske fejlbeskeder, deling af navnefeltet i contact[first_name] +
 * contact[last_name], og en øjeblikkelig, personaliseret succes-swap
 * ("Tak, {fornavn}" + download-knap) UDEN sidegenindlæsning.
 *
 * Bevidst IKKE ventet på et serversvar for succes-swappet: Shopifys
 * kunde-/kontaktformular-endpoint har ingen JSON-respons at læse (kun en
 * fuld HTML-redirect), og formularen er allerede klientvalideret, så vi
 * sender den rigtige POST i baggrunden (fetch, fire-and-forget – dette ER
 * den ægte tilmelding) og viser succes med det samme. Understøtter
 * browseren ikke fetch/FormData, falder vi tilbage til en almindelig
 * formular-submit (fuld sideindlæsning, stadig fanget af Shopify).
 *
 * shopify:section:load: sektionen gen-renderes i Theme Editor ved hver
 * indstillingsændring — boot() kører igen og springer allerede-initierede
 * rødder over via data-bd26-init (samme mønster som
 * assets/main-product-lyskaede-2026.js).
 */
(function () {
  'use strict';

  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  /**
   * Tilmeld direkte til en Klaviyo-liste via Klaviyos OFFENTLIGE
   * client-endpoint (kun public API key — den samme nøgle Klaviyos egne
   * onsite-scripts allerede eksponerer; ingen privat nøgle i browseren).
   *
   * Hvorfor: Shopify-formularen ovenfor opretter kunden og sætter
   * accepts_marketing, men Klaviyos Shopify-sync lægger profilen i
   * butikkens STANDARD-liste — ikke i messelisten. Uden dette kald bliver
   * "Boligdage"-listen aldrig fyldt, og velkomstflowet udløses aldrig.
   *
   * Fire-and-forget som Shopify-POST'en: tilmeldingen må aldrig kunne
   * blokere eller forsinke succes-visningen, og Shopify-kunden er stadig
   * den autoritative registrering hvis kaldet fejler.
   */
  function subscribeToKlaviyoList(cfg, email, first, last) {
    if (!cfg || !cfg.company || !cfg.list) return;
    if (typeof window.fetch !== 'function') return;

    // Payload-formen er verificeret mod det live endpoint (revision
    // 2024-10-15): profilen SKAL pakkes som en relationship-ressource
    // ({ data: { type: 'profile', attributes: {...} } }), og 'subscriptions'
    // er IKKE et gyldigt felt her — samtykket ligger i selve kaldet til
    // client/subscriptions. Andre former svarer 400.
    var attrs = { email: email, properties: { 'Boligdage 2026': true } };
    if (first) attrs.first_name = first;
    if (last) attrs.last_name = last;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source || 'Boligdage 2026 fribillet',
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function (err) {
      console.warn('[boligdage] Klaviyo-listetilmelding fejlede:', err);
    });
  }

  function initFribillet(root) {
    var formState = root.querySelector('[data-bd26-form-state]');
    var successState = root.querySelector('[data-bd26-success-state]');
    var form = root.querySelector('#BoligdageFribilletForm');
    if (!formState || !successState || !form) return;

    var klaviyo = {
      company: root.getAttribute('data-bd26-klaviyo-company') || '',
      list: root.getAttribute('data-bd26-klaviyo-list') || '',
      source: root.getAttribute('data-bd26-klaviyo-source') || ''
    };

    var nameInput = form.querySelector('[data-bd26-name]');
    var lastNameInput = form.querySelector('[data-bd26-lastname]');
    var emailInput = form.querySelector('[data-bd26-email]');
    var consentInput = form.querySelector('[data-bd26-consent]');
    var errorEl = form.querySelector('[data-bd26-error]');
    var submitBtn = form.querySelector('[data-bd26-submit]');
    var firstNameEl = successState.querySelector('[data-bd26-firstname]');
    var submitting = false;

    function setError(msg) {
      if (errorEl) errorEl.textContent = msg || '';
    }

    function clearErrorOnInput() {
      setError('');
    }

    form.addEventListener('input', clearErrorOnInput);
    form.addEventListener('change', clearErrorOnInput);

    function showSuccess(name) {
      var parts = (name || '').trim().split(/\s+/).filter(Boolean);
      var first = parts.shift() || '';
      if (firstNameEl && first) firstNameEl.textContent = first;
      formState.hidden = true;
      successState.hidden = false;
      successState.setAttribute('tabindex', '-1');
      successState.focus({ preventScroll: false });
    }

    form.addEventListener('submit', function (evt) {
      // Honeypot udfyldt → lad browseren sende formularen normalt (stille
      // ignoreret af Shopify), ingen optimistisk succes.
      var hp = form.querySelector('input[name="bd_hp"]');
      if (hp && hp.value.trim() !== '') return;

      if (submitting) {
        evt.preventDefault();
        return;
      }

      var fullName = nameInput ? nameInput.value : '';
      var email = (emailInput && emailInput.value || '').trim();
      var consentOk = !consentInput || consentInput.checked;

      if (!EMAIL_RE.test(email)) {
        evt.preventDefault();
        setError('Skriv en gyldig e-mailadresse.');
        if (emailInput) emailInput.focus();
        return;
      }
      if (!consentOk) {
        evt.preventDefault();
        setError('Du skal acceptere nyhedsbrevet for at få billetten.');
        return;
      }

      setError('');

      // Understøtter browseren ikke fetch/FormData, fald tilbage til en
      // almindelig submit (fuld sideindlæsning, generisk kvittering).
      if (typeof window.fetch !== 'function' || typeof window.FormData !== 'function') {
        return;
      }

      evt.preventDefault();

      // Del fulde navn op i for- og efternavn før afsendelse, så begge
      // felter reelt når Shopify/Klaviyo.
      var parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
      var first = parts.shift() || '';
      var rest = parts.join(' ');
      if (nameInput) nameInput.value = first;
      if (lastNameInput) lastNameInput.value = rest;

      submitting = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        var sendingLabel = submitBtn.getAttribute('data-sending-label');
        if (sendingLabel) submitBtn.textContent = sendingLabel;
      }

      var body = new FormData(form);

      fetch(form.action, { method: 'POST', body: body, credentials: 'same-origin' })
        .catch(function (err) {
          console.warn('[boligdage] fribillet-tilmelding fejlede i baggrunden:', err);
        });

      // Samme tilmelding, direkte til messelisten i Klaviyo, så
      // velkomstflowet udløses uden at vente på Shopify→Klaviyo-synken.
      subscribeToKlaviyoList(klaviyo, email, first, rest);

      // Ægte tilmelding er afsendt ovenfor — vis succes med det samme.
      showSuccess(fullName);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-bd26-fribillet]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.getAttribute('data-bd26-init') === '1') continue;
      root.setAttribute('data-bd26-init', '1');
      initFribillet(root);
    }
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
})();
